import { motion } from 'framer-motion';
import { ExternalLink } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Section, SectionHeader } from '@/components/ui/Section';
import { siteConfig } from '@/config/site';

export function CTASection() {
  return (
    <Section className="relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute inset-0 bg-gradient-to-r from-primary/5 via-primary/10 to-primary/5 pointer-events-none" />
      
      <div className="relative text-center">
        <SectionHeader
          subtitle="Join Us"
          title="Siap Bermain?"
          description="Bergabunglah dengan komunitas Hytale Indonesia sekarang dan rasakan pengalaman bermain yang berbeda."
        />

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.3 }}
          className="flex flex-col sm:flex-row items-center justify-center gap-4"
        >
          <Button
            asChild
            size="lg"
            className="w-full sm:w-auto bg-primary hover:bg-primary/90 text-primary-foreground font-semibold shadow-lg hover:shadow-glow transition-all"
          >
            <a
              href={siteConfig.links.discord}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2"
            >
              Join Discord
              <ExternalLink className="h-4 w-4" />
            </a>
          </Button>
          <div className="text-sm text-muted-foreground">
            IP Server:{' '}
            <code className="px-2 py-1 rounded bg-muted font-mono">
              {siteConfig.serverIP}
            </code>
          </div>
        </motion.div>
      </div>
    </Section>
  );
}
